// src/pages/gift/GiftSuccessPage.jsx — post-purchase confirmation. The code
// itself is issued and emailed by the Stripe webhook, not here.
import React from 'react';

const GiftSuccessPage = () => (
    <div className="px-6 py-20 text-white">
        <div className="mx-auto max-w-md rounded-2xl border border-white/10 bg-[#0b0e14]/60 backdrop-blur-sm p-8 text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-500/15 text-2xl">🎁</div>
            <h1 className="text-2xl font-bold">Gift sent</h1>
            <p className="mt-3 text-sm text-neutral-400">
                We've emailed the gift code to your recipient. It can be redeemed at checkout, or from
                Settings → Billing if they already have an account.
            </p>
            <a href="/" className="mt-6 inline-block bg-cyan-500 hover:bg-cyan-400 text-black font-semibold py-2 px-6 rounded-lg transition-colors">
                Back to home
            </a>
        </div>
    </div>
);

export default GiftSuccessPage;
